module.exports = __webpack_public_path__ + "f08fd284c66553326697a08dc322d58d.svg";